import { get_section_settings } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
export default {
    data() {
        return {
            sectionList: [],
        };
    },
    methods: {
        async getSectionListMethod(organization_id) {
            try {
                const result = await client.graphql({
                    query: get_section_settings,
                    variables: {
                        input: {
                            organization_id,
                        },
                    },
                });

                const responseData = JSON.parse(
                    result.data.get_section_settings
                );

                if (responseData.status === "SUCCESS") {
                    this.sectionList = responseData.data.map((item) => ({
                        ...item,
                        isenabled:
                            item.isenabled === false ? false : true,
                        overridden_fields: item.overridden_fields || [],
                    }));

                    console.log("section list", this.sectionList);
                }
            } catch (error) {
                console.log("the error", error);
            }
        }
    }
}